<template>
  <div class="personal-r">
    <h2>我的产品</h2>
    <table class="table-list column4">
      <tr>
        <th>序列</th>
        <th>产品名称</th>
        <th>权限开始时间</th>
        <th>权限终止时间</th>
      </tr>
      <tr v-for="(item, index) in periodList" :key="index">
        <td>{{index + 1}}</td>
        <td>{{item.productName}}</td>
        <td>{{item.startDt | dateFormat}}</td>
        <td>{{item.endDt | dateFormat}}</td>
      </tr>
      <tr>
        <td></td>
        <td></td>
        <td class="overdue-title">待生效</td>
        <td></td>
      </tr>
      <tr v-for="(item, index) in stopList" :key="index">
        <td>{{index + 1}}</td>
        <td>{{item.productName}}</td>
        <p style="font-size: 15px; color: #222;">“在高等级版本服务结束后，剩余<a style="color: red;">{{item.leftoverLength}}</a>天权限将自动延续。”</p>
        <td></td>
      </tr>
      <tr>
        <td></td>
        <td></td>
        <td class="overdue-title">已过期</td>
        <td></td>
      </tr>
      <tr v-for="(item, index) in expireList" :key="index" class="overdue-con">
        <td>{{index + 1}}</td>
        <td>{{item.productName}}</td>
        <td>{{item.startDt | dateFormat}}</td>
        <td>{{item.endDt | dateFormat}}</td>
      </tr>
    </table>
  </div>
</template>

<script>
export default {
  name: "PowerList",
  data() {
    return {
      periodList: [],
      expireList: [],
      stopList: [],
    };
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      this.$get("/user/powerList")
        .then(response => {
          if (response.code === 0) {
            if (response.data) {
              this.periodList = response.data.periodList;
              this.expireList = response.data.expireList;
              this.stopList = response.data.stopList;
            }
          } else if (response.code != 100) {
            this.$global.alert(response.msg);
          }
        })
        .catch(err => {
          this.$global.alertError();
        });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/scss/personal.scss";
.column4 {
  th,
  td {
    &:first-child {
      padding: 0 45px 0 35px;
    }
    &:nth-child(2) {
      width: 300px;
    }
    &:nth-child(3) {
      width: 240px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/personal/PowerList.vue